'use client'

import { useEffect } from 'react'

export function ServiceWorkerRegistration() {
  useEffect(() => {
    if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
      let registration: ServiceWorkerRegistration | null = null

      navigator.serviceWorker
        .register('/sw.js')
        .then((reg) => {
          registration = reg

          // Check for updates
          reg.addEventListener('updatefound', () => {
            const newWorker = reg.installing
            if (newWorker) {
              newWorker.addEventListener('statechange', () => {
                if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                  // New version available - could show update prompt
                  if (process.env.NODE_ENV === 'development') {
                    console.log('New service worker available')
                  }
                }
              })
            }
          })
        })
        .catch((error) => {
          if (process.env.NODE_ENV === 'development') {
            console.error('SW registration failed:', error)
          }
        })

      // Cleanup is not needed - service workers persist across page reloads
    }
  }, [])

  return null
}

